import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/******************************************************************************
 * Copyright (c) 2026 Contributors to the Eclipse Foundation.
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * https://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *****************************************************************************/
import { useState } from 'react';
import { Box, ButtonBase } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { DelayedLoadIndicator } from '../../../components/delayed-load-indicator';
import { accentHover, focusOutline, pillSurface } from '../../../components/page-primitives';
import { useReportedQuery } from '../../../hooks/use-reported-query';
import { EmptyPlaceholder } from '../settings/settings-primitives';
import { SettingsHeader } from '../settings/settings-header';
import { UserSettingsCustomerDetail } from './user-settings-customer-detail';
import { useUserCustomers } from './use-user-customers';
// Same pill treatment as the sticky tab strips: quiet surface, accent-tinted when selected.
const CustomerPill = styled(ButtonBase, { shouldForwardProp: prop => prop !== 'active' })(({ theme, active }) => ({
    ...pillSurface(theme),
    backgroundColor: theme.palette.surface2,
    fontFamily: 'inherit',
    ...(active && {
        borderColor: alpha(theme.palette.secondary.main, 0.35),
        backgroundColor: theme.palette.accentSoft,
        color: theme.palette.secondary.light,
        fontWeight: 700
    }),
    ...focusOutline(theme),
    ...(active ? {} : accentHover(theme))
}));
export const UserSettingsCustomers = () => {
    const customersQuery = useReportedQuery(useUserCustomers());
    const [chosenName, setChosenName] = useState();
    const customers = customersQuery.data ?? [];
    const loading = customersQuery.isLoading;
    const chosenCustomer = customers.find(customer => customer.name === chosenName) ?? customers[0];
    return (_jsxs(Box, { children: [_jsx(SettingsHeader, { title: 'Rate Limiting', description: 'Usage statistics and rate limits for the customer groups you belong to.' }), _jsx(DelayedLoadIndicator, { loading: loading }), customers.length > 0 && chosenCustomer ? (_jsxs(Box, { children: [customers.length > 1 ? (_jsx(Box, { sx: { display: 'flex', flexWrap: 'wrap', gap: '0.5rem', mb: '1.375rem' }, children: customers.map(customer => (_jsx(CustomerPill, { active: customer === chosenCustomer, onClick: () => setChosenName(customer.name), children: customer.name }, 'cust-' + customer.name))) })) : null, _jsx(UserSettingsCustomerDetail, { customer: chosenCustomer })] })) : !loading ? (_jsx(EmptyPlaceholder, { children: "You are not a member of any rate limiting customer group." })) : null] }));
};
//# sourceMappingURL=user-settings-customers.js.map